import { render, staticRenderFns } from "./donotsellmyinfo.vue?vue&type=template&id=747e8527&scoped=true"
import script from "./donotsellmyinfo.vue?vue&type=script&lang=js"
export * from "./donotsellmyinfo.vue?vue&type=script&lang=js"
import style0 from "./donotsellmyinfo.vue?vue&type=style&index=0&id=747e8527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e8527",
  null
  
)

export default component.exports